export default __webpack_public_path__ + "static/media/Icon metro-search.356a3487.svg";